import PropTypes from "prop-types";
import React from "react";
import s from "./ErrorMessage.pcss";

const ErrorMessage = (props) => (
    <div className={s.container} aria-live={"polite"}>
        {props.children}
    </div>
);

ErrorMessage.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ErrorMessage;
